import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';
import metricsTools from './metricsTools';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // Get all accounts
    getAccounts: (nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/vault/accounts/` +
                     `${nbItems}/${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Create a new account
    createAccount: (accountName, email, password, quota, host) => {
        const credentials = getCredentialsFromLocalStorage();
        let bytesQuota = 0;
        if (quota.length) {
            bytesQuota = Math.round(
              metricsTools.gibibytesToBytes(parseFloat(quota))
            );
        }
        const body = { accountName, email, host, quota: bytesQuota };
        if (password) {
            body.password = password;
        }
        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/vault/accounts`)
                .set('x-access-token', credentials)
                .send(body)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete an account
    deleteAccount: accountName => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .delete(
                  `${apiUrlProvider.apiUrl()}/vault/accounts/${accountName}`
                )
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    deleteUserForAccount: (accountName, host) => {
        const credentials = getCredentialsFromLocalStorage();
        const url = apiUrlProvider.apiUrl();
        return new Promise((resolve, reject) => {
            request
                .delete(`${url}/vault/accounts/${accountName}/user`)
                .set('x-access-token', credentials)
                .send({ host })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Generate credentials for specified account
    generateCredentialsForAccount: (accountName, password, host) => {
        const credentials = getCredentialsFromLocalStorage();
        const url = apiUrlProvider.apiUrl();
        return new Promise((resolve, reject) => {
            request
                .put(`${url}/vault/accounts/${accountName}/password`)
                .set('x-access-token', credentials)
                .send({ password, host })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Generate key pair for specified account
    generateKeysForAccount: accountName => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(
                `${apiUrlProvider.apiUrl()}/vault/accounts/${accountName}/keys`
                )
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get keys for specified account
    getKeysForAccount: accountName => {
        const credentials = getCredentialsFromLocalStorage();
        return new Promise((resolve, reject) => {
            request
                .get(
                `${apiUrlProvider.apiUrl()}/vault/keys/${accountName}`
                )
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete key for specified account
    deleteKeyForAccount: (accountName, key) => {
        const credentials = getCredentialsFromLocalStorage();
        const ep = `${apiUrlProvider.apiUrl()}/vault/accounts/${accountName}` +
        `/key/${key}`;

        return new Promise((resolve, reject) => {
            request
                .delete(ep)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Create a new account quota
    setQuotaForAccount: (accountName, quota) => {
        const credentials = getCredentialsFromLocalStorage();
        let bytesQuota = 0;
        if (quota.length) {
            bytesQuota = Math.round(
              metricsTools.gibibytesToBytes(parseFloat(quota))
            );
        }
        const body = { quota: bytesQuota };
        const url = `${apiUrlProvider.apiUrl()}/vault/accounts/` +
        `${accountName}/quota`;
        return new Promise((resolve, reject) => {
            request
                .post(url)
                .set('x-access-token', credentials)
                .send(body)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete an account quota
    deleteQuotaForAccount: accountName => {
        const credentials = getCredentialsFromLocalStorage();
        const url = apiUrlProvider.apiUrl();
        return new Promise((resolve, reject) => {
            request
                .delete(`${url}/vault/accounts/${accountName}/quota`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get quota when logged in as an account
    accountGetQuotaForAccount: accountId => {
        const credentials = getCredentialsFromLocalStorage();
        return new Promise((resolve, reject) => {
            request
                .get(
                `${apiUrlProvider.apiUrl()}/vault/admin/quota/${accountId}`
                )
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get account Id
    getAccountId: () => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/account/id`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Change own password
    changeSelfPassword: (currentPassword, newPassword) => {
        const credentials = getCredentialsFromLocalStorage();
        const body = {
            currentPassword,
            newPassword
        };

        return new Promise((resolve, reject) => {
            request
                .put(`${apiUrlProvider.apiUrl()}/vault/self/password`)
                .set('x-access-token', credentials)
                .send(body)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(response.status === 204 ? {} : {});
                });
        });
    },
};



/** WEBPACK FOOTER **
 ** ./src/utils/AccountsAPI.js
 **/